"use client"

import { useEffect } from "react"
import { useParams, Outlet, Navigate } from "react-router-dom"
import { useTranslation } from "react-i18next"

function LanguageRouter({ supportedLanguages }) {
  const { lang } = useParams()
  const { i18n } = useTranslation()

  // First useEffect - check and set language
  useEffect(() => {
    if (lang && i18n.language !== lang && supportedLanguages.includes(lang)) {
      i18n.changeLanguage(lang)
    }
  }, [lang, i18n, supportedLanguages])

  // Check if language is supported
  const isLanguageSupported = supportedLanguages.includes(lang)

  // After all hooks are called, we can have conditional returns
  if (!isLanguageSupported) {
    return <Navigate to={`/${i18n.language}`} replace />
  }

  // Render the child routes
  return <Outlet />
}

export default LanguageRouter
